"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplates = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const notification_context_1 = require("../notification/notification-context");
const authored_evidence_1 = require("../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const crud_source_hook_1 = require("../../utils/crud-source-hook");
const empty_component_1 = require("../../utils/empty-component");
const notification_template_actionbar_1 = require("./notification-template-actionbar");
const notification_template_columns_1 = require("./notification-template-columns");
const notification_template_context_1 = require("./notification-template-context");
const notification_template_fields_1 = require("./notification-template-fields");
const notification_template_schema_1 = require("./notification-template-schema");
function NotificationTemplates(props) {
    const intl = (0, react_intl_1.useIntl)();
    const { notificationEventUrl, notificationTemplateUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const validationSchema = (0, notification_template_schema_1.useValidationSchema)();
    const columns = (0, notification_template_columns_1.useColumns)();
    const evidence = (0, authored_evidence_1.useAuthoredEvidence)({
        identifier: 'NOTIFICATION_TEMPLATES',
        apiProps: {
            url: notificationTemplateUrl,
            getItem: (0, crud_source_hook_1.getItemFactory)({
                postProcess: postProcess(notificationEventUrl),
            }),
            updateItem: (0, crud_source_hook_1.updateItemFactory)({
                preProcess,
                postProcess: postProcess(notificationEventUrl),
            }),
            createItem: (0, crud_source_hook_1.createItemFactory)({
                preProcess,
                postProcess: postProcess(notificationEventUrl),
            }),
        },
        tableProps: {
            tableName: intl.formatMessage({
                id: 'EAS_NOTIFICATION_TEMAPLTES_TABLE_TITLE',
                defaultMessage: 'Šablony notifikací',
            }),
            columns,
            showReportButton: false,
            showBulkActionButton: false,
        },
        detailProps: {
            FieldsComponent: notification_template_fields_1.Fields,
            GeneralFieldsComponent: empty_component_1.EmptyComponent,
            validationSchema,
            toolbarProps: {
                title: intl.formatMessage({
                    id: 'EAS_NOTIFICATION_TEMPLATES_DETAIL_TITLE',
                    defaultMessage: 'Šablona',
                }),
                ActionBar: notification_template_actionbar_1.ActionBar,
            },
        },
    });
    return (react_1.default.createElement(notification_template_context_1.NotificationTemplateContext.Provider, { value: props },
        react_1.default.createElement(evidence_1.Evidence, { ...evidence })));
}
exports.NotificationTemplates = NotificationTemplates;
const preProcess = (item) => {
    return {
        ...item,
        event: item.event.id,
    };
};
const postProcess = (url) => async (item) => {
    const response = await fetch(`${url}/${item === null || item === void 0 ? void 0 : item.event}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
    const event = await response.json();
    return { ...item, event };
};
//# sourceMappingURL=notification-templates.js.map